import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { fromIsoDateString } from "../../../common/helpers/formatDateTime";

interface Props {
  verificationDate: string;
}

const SalesPermissionText = ({ verificationDate }: Props) => {
  const { t } = useTranslation("customers");
  return (
    <Typography>
      {t(`customers:salesPermissionVerified`, {
        date: fromIsoDateString(verificationDate, "dd.MM.yyyy"),
      })}
    </Typography>
  );
};

export default SalesPermissionText;
